<template>
	<div class="flex flex-grow">
		<div class="w-full flex flex-col gap-6">
			<!-- BLOCK 1: Vertrag + DPA -->

			<div class="p-4 border rounded">
				<div class="font-semibold mb-4">
					{{ $t('contract_block_title') }}
				</div>

				<div class="flex gap-12 items-center">
					<div class="flex flex-col gap-3">
						<div class="flex justify-start gap-12 items-center">
							<BaseButton @click="$emit('downloadTos')" style="min-width: 310px">
								{{ $t('toc_read') }}
							</BaseButton>
							<div class="flex">
								<BaseCheckbox
									ref="acceptContract"
									v-model="acceptContract"
									:label="$t('accept_tos_explanation')"
									:required="true"
									error-message=" "
								/>
							</div>
						</div>

						<div class="flex justify-start gap-12 items-center">
							<BaseButton @click="$emit('downloadSupportPolicy')" style="min-width: 310px">
								{{ $t('support_policy_read') }}
							</BaseButton>
							<div class="flex">
								<BaseCheckbox
									ref="acceptSupportPolicy"
									v-model="acceptSupportPolicy"
									:label="$t('accept_support_policy_explanation')"
									:required="true"
									error-message=" "
								/>
							</div>
						</div>

						<div class="flex justify-start gap-12 items-center">
							<BaseButton @click="$emit('downloadDpaAvvFile')" style="min-width: 310px">
								{{ $t('dpa_read') }}
							</BaseButton>
							<div class="flex">
								<BaseCheckbox
									ref="acceptDPA"
									v-model="acceptDPA"
									:label="$t('accept_dpa_explanation')"
									:required="true"
									error-message=" "
								/>
							</div>
						</div>

						<div class="flex justify-start gap-12 items-center">
							<BaseButton @click="$emit('downloadDpaAvvAnnex1File')" style="min-width: 310px">
								{{ $t('dpa_attachment_1_read') }}
							</BaseButton>
							<div class="flex">
								<BaseCheckbox
									ref="acceptTOMs"
									v-model="acceptTOMs"
									:label="$t('accept_dpa_annex_1_toms_explanation')"
									:required="true"
									error-message=" "
								/>
							</div>
						</div>

						<div class="flex justify-start gap-12 items-center">
							<BaseButton @click="$emit('downloadDpaAvvAnnex2File')" style="min-width: 310px">
								{{ $t('dpa_attachment_2_read') }}
							</BaseButton>
							<div class="flex">
								<BaseCheckbox
									ref="acceptSCC"
									v-model="acceptSCC"
									:label="$t('accept_dpa_annex_2_scc_explanation')"
									:required="true"
									error-message=" "
								/>
							</div>
						</div>
					</div>
				</div>
			</div>


			<!-- BLOCK 2: Datenschutz -->

			<div class="p-4 border rounded">
				<div class="font-semibold mb-3">
					{{ $t('privacy_block_title') }}
				</div>

				<div class="flex flex-col gap-3">
					<div class="flex justify-start gap-12 items-center">
						<BaseButton @click="$emit('downloadDataProtection')" style="min-width: 310px">
							{{ $t('data_protection_read') }}
						</BaseButton>

						<div class="flex">
							<BaseCheckbox
								ref="acceptPrivacy"
								v-model="acceptPrivacy"
								:label="$t('accept_data_protection_explanation')"
								:required="true"
								error-message=" "
							/>
						</div>
					</div>
					<div class="flex justify-start gap-12 items-center">
						<BaseButton @click="$emit('downloadConsentPolicy')" style="min-width: 310px">
							{{ $t('consent_policy_read') }}
						</BaseButton>

						<div class="flex">
							<BaseCheckbox
								ref="acceptPrivacy"
								v-model="acceptConsent"
								:label="$t('accept_consent_policy_explanation')"
								:required="true"
								error-message=" "
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import BaseCheckbox from '@/components/forms/inputs/BaseCheckbox.vue';
import BaseButton from '@/components/forms/buttons/BaseButton.vue';
import Validate from '@/mixins/Validate';

export default {
	name: 'OnboardingTermsAndConditions',
	components: { BaseButton, BaseCheckbox },
	mixins: [Validate],
	data() {
		return {
			acceptContract: false,
			acceptSupportPolicy: false,
			acceptDPA: false,
			acceptTOMs: false,
			acceptSCC: false,
			acceptPrivacy: false,
			acceptConsent: false,
		};
	},
};
</script>

<style scoped>
.form-group {
	margin: 0 !important;
}
</style>
